__turbopack_context__.v({
  "active": "XxDyfq_active",
  "centreItem": "XxDyfq_centreItem",
  "centreLink": "XxDyfq_centreLink",
  "circle": "XxDyfq_circle",
  "circleCount": "XxDyfq_circleCount",
  "face": "XxDyfq_face",
  "faceCart": "XxDyfq_faceCart",
  "faceJetman": "XxDyfq_faceJetman",
  "flipBack": "XxDyfq_flipBack",
  "flipper": "XxDyfq_flipper",
  "iconContainer": "XxDyfq_iconContainer",
  "label": "XxDyfq_label",
  "navBar": "XxDyfq_navBar",
  "navBarItems": "XxDyfq_navBarItems",
  "navBarSpacer": "XxDyfq_navBarSpacer",
  "navItem": "XxDyfq_navItem",
  "navItemLink": "XxDyfq_navItemLink",
  "pop-in": "XxDyfq_pop-in",
  "spin-to-cart": "XxDyfq_spin-to-cart",
  "spin-to-jetman": "XxDyfq_spin-to-jetman",
});
